module.exports = __webpack_public_path__ + "static/media/logo.b785a6f6.svg";